import React from 'react'
import { Alert } from '@ztechapps/webui.util'
import { belowMinimumOrderAmountPaymentBlockMessage } from '@ztechapps/order.common'
import { useOrderDocument } from './hooks/useOrderDocument'

export const MinimumOrderAmountNote = () => {
  const { document } = useOrderDocument()

  return <Alert type="warning">{belowMinimumOrderAmountPaymentBlockMessage(document)}</Alert>
}
